var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAIusage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_1121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2378 13.762H31.9362C31.4541 9.48742 28.4423 1.47398 18.2378 0V13.762Z",
    fill: "#3A57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3336 1.75317C6.3976 2.20981 0.0639648 8.82409 0.0639648 16.8889C0.0639648 25.2339 6.82019 32 15.1396 32C23.1666 32 29.7375 25.7299 30.1904 17.6659H14.3336V1.75317Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_1121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIusage1);
export default __webpack_public_path__ + "static/media/AI usage 1.d2927aec56b7eccaf3db5c7ba1d9a085.svg";
export { ForwardRef as ReactComponent };